import { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { Field } from 'formik';
import { useAppSelector } from 'store/hooks/useAppSelector';
import { getIsReadonlySelector } from 'store/selectors/auth';
import { t } from 'ttag';

import { ChangeScreenSection } from 'components/common/ChangeScreenSection';
import { FieldInput } from 'components/common/FieldInput';

import { ChangeScreenFormProps } from '../../types';

import { styles } from './styles';

export const AdditionsDataTabLoadingSpace: FC<ChangeScreenFormProps> = () => {
  const readOnly = useAppSelector(getIsReadonlySelector);

  return (
    <ChangeScreenSection label={t`Loading space`}>
      <Grid container columns={1} rowGap={2}>
        <Grid container columns={1} spacing={2} rowGap={4}>
          <Grid item mobile={1} sx={styles.gridItem}>
            <Field
              component={FieldInput}
              name="extraPalletSpace"
              label={t`Extra pallet space`}
              placeholder={t`Enter extra pallet space`}
              type="number"
              disabled={!!readOnly}
            />
            <Typography>{t`pcs`}</Typography>
          </Grid>
          <Grid item mobile={1} sx={styles.gridItem}>
            <Field
              component={FieldInput}
              name="flatbedMeter"
              label={t`Flatbed meter`}
              placeholder={t`Enter flatbed meter`}
              type="number"
              disabled={!!readOnly}
            />
            <Typography>{t`m`}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </ChangeScreenSection>
  );
};
